(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["New-slideshow"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .home-slideshow .variable-width");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
              dots: false,
     		  slidesToScroll: 1,
      		 
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
    new Swiper('#blog-slider', {
        loop: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 0,
        breakpoints: {
            
        }
    });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-block-brands"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
      var carousel = $('[data-owl]');
		  carousel = $('.widget-carousel-brands .brands-grid');
      if (carousel.length) {
         carousel.each(function(index, el) {
            $(this).owlCarousel($(this).data('owl'));
         });
	  }
}    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-block-trending"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
      var carousel = $('[data-owl]');
		  carousel = $('.widget-trending-product .products-grid');
      if (carousel.length) {
         carousel.each(function(index, el) {
            $(this).owlCarousel($(this).data('owl'));
         });
	  }
}    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-backup-uso"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
const activeMediaTemplate = activeMedia.querySelector('template');
const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

const container = this.querySelector('[role="document"]');
container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-search-template"]) return;
  try {
    
$(document).ready(function() {
   $.getJSON('/cart.js', function(cart) {
      $('.floating-basket').removeClass('hide');
      $('.floating-basket .fb-count > span').text(cart.item_count);

    // alert(cart.original_total_price);
     cart_total = cart.original_total_price
     cart_total = cart_total.toString();
     cart_total_1 = cart_total.slice(0, -2);
     cart_total_2 = cart_total.slice(-2);

     if (cart_total=="0"){
       $('.floating-basket .fb-total').text('$0.00');
     }else{
       $('.floating-basket .fb-total').text('$'+formatNumber(cart_total_1)+'.'+cart_total_2);
     }
     
    });

//DISPLAYING BRANDS PRODUCTS
var default_selected_brand = $('#search-option').find(":selected").val();

$('#data-table tbody tr').hide();
$('#data-table tbody tr.'+default_selected_brand).show();

$('#search-option').on("change", function(){
  var selected_brand = $('#search-option').find(":selected").val();
  $('#data-table tbody tr').hide();
  $('#data-table tbody tr.'+selected_brand).show();
});

//TOGGLE OPTIONS
$('.has_options').on("click", function(e){
  e.preventDefault();
  var has_options_id = $(this).attr("data-variant-id");
  if($(this).hasClass("active")){
    $('.variant-item-'+has_options_id).attr('style', 'display: none !important');
    $(this).removeClass("active");
  }else{
    $('.variant-item-'+has_options_id).attr('style', 'display: table-row !important');
    $(this).addClass("active");
  }

});

// ADD TO CART
$('.quick-add-to-cart').on("click",function(e){
    e.preventDefault();

   var product_id = $(this).closest("form").children(".variant-id").val();
   var product_title = $(this).parents(".product-card").find(".product-card__title").text();
   var product_qty = $(this).closest("form").find("#quantity").val();

 let formData = {
   'items': [{
    'id': product_id,
    'quantity': product_qty
    }]
  };
 
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    $('.btn-item-added.btn-'+product_id).removeClass("hidden");
    setTimeout(function (product_id) {
      $('.btn-item-added.btn-'+product_id).addClass("hidden");
    }, 1200, product_id);

    //UPDATE CART
    $.getJSON('/cart.js', function(cart) {
      $('#CartCount').removeClass('hide');
      $('#CartCount span:first-child').text(cart.item_count);
    });

    //UPDATE FLOATING CART
    $.getJSON('/cart.js', function(cart) {
      $('.floating-basket').removeClass('hide');
      $('.floating-basket .fb-count > span').text(cart.item_count);

       cart_total = cart.original_total_price
       cart_total = cart_total.toString();
       cart_total_1 = cart_total.slice(0, -2);
       cart_total_2 = cart_total.slice(-2);

       if (cart_total=="0"){
         $('.floating-basket .fb-total').text('$0.00');
       }else{
         $('.floating-basket .fb-total').text('$'+formatNumber(cart_total_1)+'.'+cart_total_2);
       }
    });
    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
});

$(".cart-popup__close, .cart-popup__dismiss-button").on("click", function(){
  $('.cart-popup-wrapper--hidden').css({'display':'none'});
});

$('.adjust-qty-btn.plus').on("click",function(){
  if ($(this).prev().val() < 1000) {
  $(this).prev().val(+$(this).prev().val() + 1);
  }
});
$('.adjust-qty-btn.minus').on("click", function(){
      if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
      }
});

function formatNumber (num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
}

$.extend(true, $.fn.dataTable.defaults, {
    dom: 'Blfrtip',
        buttons: [
            'copy', 'csv', 'excel', 'print'
        ]
  });
    $('#data-table').DataTable( {
    	"order": [],
        "paging":   false,
         language: { 
                search: "",
                searchPlaceholder: "Search all products",
              },
    } );
  
} );

$(window).load(function() {

  $("#data-table_filter input").click(function(){
  $('#data-table tbody tr').show();
});
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-not-logged"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
  var _slick = $( "#" +evt.target.id + " .home-slideshow .variable-width");
  if( _slick.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + _slick.attr("id"));
        _slick.slick (
            {
              dots: false,
     		  slidesToScroll: 1,
      		 
              autoplay: _slick.data('slick').autoplay,
              autoplaySpeed: _slick.data('slick').autoplaySpeed
            }
          );
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + _slick.attr("id"));
        _slick.slick('unslick');
      break;

     } 
  }
}
    
$(document)
 .on( 'shopify:section:load', process_slick_event )
 .on( 'shopify:section:unload', process_slick_event );


  } catch(e) { console.error(e); }
})();
})();
